@if (isIdInvalid) {
  <p class="invalid-message">Invalid ID. Please check the URL.</p>
}

@if (isSubmitted) {
  <p class="submission-message">
    @if (cdfiForm.opt_out) {
      Thank you for your submission.
    } @else {
      Thank you for your submission. We will get back to you soon.
    }
  </p>
}

@if (!loading) {
  @if (!isIdInvalid && !isSubmitted) {
    <div class="page-layout">
      <div class="form-container">
        <div class="form-header">
          <div class="header-content">
            <div class="form-title">Small Business Outreach Form</div>
          </div>
        </div>
        <form (ngSubmit)="onSubmit()" class="cdfi-form">
          <div class="form-grid">
            <div class="form-group">
              <label for="name" class="required">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                [(ngModel)]="cdfiForm.name"
                (ngModelChange)="onFieldChange('name', $event)"
                placeholder="Enter your name..."
                required
                [class.invalid]="cdfiForm.name && !isNameValid()"
              />
              @if (cdfiForm.name && !isNameValid()) {
                <span class="error-message">Name is too long</span>
              }
            </div>
            <div class="form-group">
              <label for="email" class="required">Email</label>
              <input
                id="email"
                type="email"
                name="email"
                [(ngModel)]="cdfiForm.email"
                (ngModelChange)="onFieldChange('email', $event)"
                placeholder="Enter your email..."
                [class.invalid]="cdfiForm.email && !isEmailValid()"
                required
              />
              @if (cdfiForm.email && !isEmailValid()) {
                <span class="error-message"
                  >Please enter a valid email address</span
                >
              }
            </div>
            <div class="form-group">
              <label for="phone">Phone</label>
              <input
                id="phone"
                type="tel"
                name="phone"
                [(ngModel)]="cdfiForm.phone"
                placeholder="Enter your phone..."
                [class.invalid]="cdfiForm.phone && !isPhoneValid()"
              />
              @if (cdfiForm.phone && !isPhoneValid()) {
                <span class="error-message"
                  >Please enter a valid phone number</span
                >
              }
            </div>
            <div class="form-group">
              <label for="contact-method" class="required"
                >Preferred contact method</label
              >
              <select
                id="contact-method"
                name="contactMethod"
                [(ngModel)]="cdfiForm.contactMethod"
                (ngModelChange)="onFieldChange('contactMethod', $event)"
                required
              >
                <option value="" selected>Select contact method</option>
                <option value="Email">Email</option>
                <option value="Phone">Phone</option>
              </select>
            </div>
            <div class="form-group">
              <label for="business-name">Business Name</label>
              <input
                id="business-name"
                type="text"
                name="businessName"
                [(ngModel)]="cdfiForm.businessName"
                placeholder="Enter your business name..."
                [class.invalid]="
                  cdfiForm.businessName && !isBusinessNameValid()
                "
              />
              @if (cdfiForm.businessName && !isBusinessNameValid()) {
                <span class="error-message">Business Name is too long</span>
              }
            </div>
            <div class="form-group">
              <label for="service-request" class="required"
                >I would like support with ...</label
              >
              <select
                id="service-request"
                name="serviceRequest"
                [(ngModel)]="cdfiForm.serviceRequest"
                (ngModelChange)="onFieldChange('serviceRequest', $event)"
                required
              >
                <option value="" selected>Select</option>
                <option value="Ongoing resources and support">
                  Ongoing resources and support
                </option>
                <option value="Information about loans for recovery">
                  Information about loans for recovery
                </option>
                <option value="Information about loans for growth">
                  Information about loans for growth
                </option>
                <option value="Commercial Real Estate">
                  Commercial Real Estate
                </option>
                <option value="Affordable Housing">Affordable Housing</option>
                <option value="Debt Consolidation">Debt Consolidation</option>
              </select>
            </div>
            <div class="consent-checkboxes">
              <div class="checkbox-group" [class.disabled]="cdfiForm.opt_out">
                <input
                  type="checkbox"
                  id="consentCheck"
                  name="cdfi_contact_agree"
                  [(ngModel)]="cdfiForm.cdfi_contact_agree"
                  [disabled]="cdfiForm.opt_out"
                  required
                />
                <label
                  for="consentCheck"
                  [class.disabled]="cdfiForm.opt_out"
                  class="required"
                >
                  By checking this box, you are submitting your application to
                  ACC and its 3rd Party affiliate network of private CDFIs and
                  Business Support organizations, and that service or contact is
                  not guaranteed, and any decision of service or contact is at
                  the discretion of participating organizations. You hereby
                  allow ACC and its trusted 3rd party affiliates to view,
                  analyze, and share your application in-network and to trusted
                  organizations.
                </label>
              </div>
              <div
                class="checkbox-group"
                [class.disabled]="cdfiForm.cdfi_contact_agree"
              >
                <input
                  type="checkbox"
                  id="optOutCheck"
                  name="opt_out"
                  [(ngModel)]="cdfiForm.opt_out"
                  [disabled]="cdfiForm.cdfi_contact_agree"
                  required
                />
                <label
                  for="optOutCheck"
                  [class.disabled]="cdfiForm.cdfi_contact_agree"
                  class="required"
                >
                  If you would like to opt out of communications from ACC and
                  its partners, please check this box.
                </label>
              </div>
            </div>
            <div class="cdfi-info-section">
              <div
                class="section-header"
                (click)="toggleCDFIInfo()"
                (keydown)="handleCDFIInfoKeydown($event)"
                tabindex="0"
              >
                <h3>About our partner organizations</h3>
                <svg
                  [class.rotated]="showCDFIInfo"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="12"
                  height="12"
                >
                  <path
                    d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                  />
                </svg>
              </div>
              @if (showCDFIInfo) {
                <div class="cdfi-info-content">
                  @for (cdfi of cdfiInfo; track cdfi.name) {
                    <div class="cdfi-card">
                      @if (cdfi.logo) {
                        <div class="logo-container">
                          <img
                            [src]="cdfi.logo"
                            [alt]="cdfi.name + ' Logo'"
                            class="cdfi-logo"
                          />
                        </div>
                      }
                      <h4>{{ cdfi.name }}</h4>
                      <p [innerHTML]="cdfi.description"></p>
                      <a
                        [href]="cdfi.website"
                        target="_blank"
                        class="website-link"
                        >Visit Website</a
                      >
                    </div>
                  }
                </div>
              }
            </div>
            <div
              class="form-group"
              (click)="onFormClick($event)"
              (keydown)="onFormClick($event)"
              tabindex="0"
              [class.disabled-section]="!cdfiForm.cdfi_contact_agree"
            >
              <div class="label-with-info">
                <label for="cdfi-interest"
                  >Partner organizations of interest</label
                >
              </div>
              @if (selectedCDFIPreferences.length > 0) {
                <div class="selected-tags">
                  @for (tag of selectedCDFIPreferences; track $index) {
                    <span class="tag">
                      {{ $index + 1 }}.
                      {{ tag.display_name || tag.connection_name }}
                      <button
                        type="button"
                        (click)="$event.stopPropagation(); removeTag(tag)"
                        [disabled]="!cdfiForm.cdfi_contact_agree"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 384 512"
                          width="18px"
                          height="18px"
                        >
                          <path
                            d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                          ></path>
                        </svg>
                      </button>
                    </span>
                  }
                </div>
              }
              <div
                class="custom-dropdown"
                (click)="toggleDropdown()"
                (keydown)="handleKeydown($event)"
                tabindex="0"
                [class.disabled]="cdfiForm.cdfi_contact_agree"
              >
                <div class="cdfi_selected_text">
                  <span>Select</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    width="12"
                    height="12"
                    color="#000000"
                  >
                    <path
                      d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                    />
                  </svg>
                </div>
                @if (dropDownOpen) {
                  <div class="dropdown-content">
                    <div class="dropdown-search">
                      <input
                        type="text"
                        [(ngModel)]="searchText"
                        (ngModelChange)="filterCDFIs()"
                        (click)="$event.stopPropagation()"
                        placeholder="Search partner organization..."
                        name="cdfiSearch"
                      />
                    </div>
                    @if (selectedCDFIPreferences.length >= maxCDFI) {
                      <div class="dropdown-max-message">
                        Maximum of {{ maxCDFI }} partner organizations can be
                        selected
                      </div>
                    }
                    @for (option of filteredCDFIPreferences; track option.id) {
                      <div
                        class="dropdown-option"
                        [class.disabled]="isOptionDisabled(option)"
                      >
                        <input
                          type="checkbox"
                          [id]="option.id"
                          [value]="
                            option.display_name || option.connection_name
                          "
                          [checked]="selectedCDFIPreferences.includes(option)"
                          (change)="onCheckboxChange(option, $event)"
                          [disabled]="isOptionDisabled(option)"
                        />
                        <label
                          [for]="option.id"
                          [class.disabled]="isOptionDisabled(option)"
                          >{{
                            option.display_name || option.connection_name
                          }}</label
                        >
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="form-group">
              <label for="additional-details">Any additional details?</label>
              <textarea
                id="additional-details"
                name="additionalDetails"
                [(ngModel)]="cdfiForm.additionalDetails"
                placeholder="Enter any additional details..."
                [class.invalid]="
                  cdfiForm.additionalDetails && !isAdditionalDetailsValid()
                "
              ></textarea>
              @if (cdfiForm.additionalDetails && !isAdditionalDetailsValid()) {
                <span class="error-message"
                  >Additional Details is too long</span
                >
              }
            </div>
          </div>
          <div class="form-actions">
            <button type="submit" [disabled]="!isFormValid()">Submit</button>
          </div>
        </form>
      </div>
    </div>
  }
}

@if (loading) {
  <div class="page-layout">
    <div class="form-container">
      <div class="form-header">
        <div class="header-content">
          <div class="form-title">Small Business Outreach Form</div>
          <div class="info-button-load"></div>
        </div>
      </div>
      <div class="cdfi-form-load">
        <div class="form-grid-load">
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="input-load"></div>
          </div>
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="input-load"></div>
          </div>
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="input-load"></div>
          </div>
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="input-load"></div>
          </div>
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="input-load"></div>
          </div>
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="input-load"></div>
          </div>
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="input-load"></div>
          </div>
          <div class="radio-group-load">
            <div class="label-load"></div>
            <div class="radio-options-load"></div>
          </div>
          <div class="form-group-load">
            <div class="label-load"></div>
            <div class="textarea-load"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
